const getAgentStatus = (lastCheckIn, interval = 5) => 
  lastCheckIn !== undefined 
    && Date.parse(lastCheckIn) > (Date.now() - (interval * 60 * 1000));

export default getAgentStatus;